module.exports = __webpack_public_path__ + "img/arrow(back).af35abd0.svg";